<template>
  <div>
    <div class="head_c">
      <div class="title">累计使用： <span>100</span></div>
      <div class="flex_c">
        <div>
          <p style="font-weight: 900">100</p>
          <p>当月使用</p>
        </div>
        <div>
          <p style="font-weight: 900">100</p>
          <p>累计积分</p>
        </div>
      </div>
      <div class="time">
        <van-field v-model="text" @click="naturePicker = true" input-align="center"/>
      </div>
      <div>
        <van-popup v-model="naturePicker" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="timeConfirm"
            @cancel="naturePicker = false"
          />
        </van-popup>
      </div>
    </div>
    <div>
      <div class="tab_con m_flex_box flex_vb">
        <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
          >全部兑换</span
        >
        <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
          >好物</span
        >
        <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
          >卡券</span
        >
      </div>
      <div class="list_main">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="" />
          </div>
          <div class="list_con pre_list">
            <div
              class="inner m_flex_box"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="inner_l">
                <!-- <img
                  class="banner"
                  v-lazy="imgPath + 'sImgMin/' + item.imgid + '.jpg'"
                /> -->
                <p class="num">10000积分</p>
                <!-- <i v-show="index < 3">最新</i> -->
              </div>
              <div class="new_r">
                <div class="m_flex_box flex_vc flex_jz tit">
                  <h4 class="line_comp1">{{ item.itemName }}</h4>

                  <span class="span_one" v-if="item.jdStatus == '好物'">{{
                    item.jdStatus
                  }}</span>
                  <span class="span_two" v-if="item.jdStatus == '卡券'">{{
                    item.jdStatus
                  }}</span>
                </div>
                <div>
                  <p class="line_comp1 col_gray">
                    领取方式:{{ item.preItemName }}
                  </p>
                  <p class="line_comp1 col_gray">商家:{{ item.corpName }}</p>
                  <p class="line_comp1 col_gray">地址:{{ item.itemSite }}</p>
                  <p class="line_comp1 col_gray">货码:{{ item.itemSite1 }}</p>
                  <p class="line_comp1 col_gray">
                    兑换日期:{{ item.itemSite2 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "2016-1",
      tab: 0,
      naturePicker: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      list: [
        {
          itemName: "weqeqwe",
          jdStatus: "好物",
          preItemName: "awqeqweq",
          corpName: "ewqeqweqwe",
          itemSite: "dsadasdasdas",
          itemSite1: "daszczczxc",
          itemSite2: "eqwexdasd",
        },
      ],
    };
  },
  created() {
    var date = new Date();
    var year = date.getFullYear(); // 获取完整的年份(4位,1970)
    var month = date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)F
    this.text = year + "-" + month;
  },
  methods: {
    timeConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear(); // 获取完整的年份(4位,1970)
      var month = date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)F
      this.text = year + "-" + month;
      this.naturePicker = false;
    },
    changeTab(num) {
      this.tab = num;
    },
  },
};
</script>
<style lang="less" scoped>
.head_c {
  padding: 0.5rem 0;
  background: #007fff;
  overflow: hidden;
  .title {
    color: #fff;
    font-size: 0.27rem;
    text-align: center;
    padding: 0.3rem 0;
    span {
      font-size: 0.6rem;
      font-weight: 900;
    }
  }
  .flex_c {
    display: flex;
    & > div {
      flex: 1;
      p {
        color: #fff;
        font-size: 0.27rem;
        padding: 5px 0;
        text-align: center;
      }
    }
  }
  .time {
    width: 1.5rem;
    float: right;
    overflow: hidden;
    padding-top: 0.1rem;
    .van-cell {
      padding: 0;
    }
  }
}

.tab_con {
  height: 1rem;
  background-color: #fff;
  display: flex;
  z-index: 9;
  span {
    flex: 1;
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    position: relative;
    text-align: center;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      // margin-left: -0.2rem;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 0.7rem;
      height: 0.04rem;
    }
  }
}
.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;
  .inner {
    padding: 0.35rem 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .banner {
    width: 2.44rem;
    height: 2rem;
  }
  .inner_l {
    flex: 1;
    position: relative;
    .num {
      color: #24d064;
      text-align: center;
    }
  }
  .new_r {
    .tel {
      width: 0.36rem;
      height: 0.36rem;
      img {
        width: 100%;
      }
    }
    img {
      width: 100%;
    }
    width: 4.25rem;
    margin-left: 0.3rem;
    .col_gray {
      font-size: 0.24rem;
      color: #505050;
      i {
        margin: 0 0.2rem;
      }
    }
    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 2.6rem;
      }
      i {
        //width: 0.6rem;
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2f72f5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }
      span {
        text-align: center;
        line-height: 0.34rem;
        padding: 0.03rem 0.1rem;
        color: #ffffff;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
      .span_one {
        background-color: #ff6666;
      }
      .span_two {
        background-color: #00cc00;
      }
    }
  }
}
.pre_list {
  .col_gray {
    &:not(:last-child) {
      margin: 0.1rem 0;
    }
  }
}
</style>